import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import { currencyName, currencyCode } from 'Helpers/Geo/data';
import { getAll } from 'Config/lang';
import LanguageModalButton from 'Containers/Utility/LanguageModalContainer';

const messages = defineMessages({
  change: {
    id: 'account-language.changeLanguage',
    defaultMessage: 'Change Language',
  },
  changeCurrency: {
    id: 'account-language.changeCurrency',
    defaultMessage: 'Change Display Currency / Language',
  },
});

function AccountLanguage({ language, intl }) {
  const { formatMessage } = intl;
  if (getAll().length < 2) {
    return false;
  }
  const countryData = window.countryData || {};
  const hasNativePrice = countryData['Native-Currency-Alphabetic-Code'] && countryData['Native-Currency-Alphabetic-Code'] !== countryData['Currency-Alphabetic-Code'];
  let languageLabel = countryData['Currency-Name'];

  const currentCurrency = localStorage.getItem('displayCurrency');

  if (currentCurrency && countryData['Native-Currency-Alphabetic-Code'] && currentCurrency === countryData['Native-Currency-Alphabetic-Code']) {
    languageLabel = countryData['Native-Currency-Name'];
  }

  return (
    <React.Fragment>
      <div className="account-table-row">
        <div className="account-table-row-title">
          <FormattedMessage id="account.setting.title.language" defaultMessage="Site Language" />
        </div>
        <div className="account-table-row-content">
          <div className="account-table-details-container">
            { (language && language.nativeLabel) || 'English' }
          </div>
          <div className="account-table-action-container">
            <LanguageModalButton hideCaret buttonText={formatMessage(messages.change)} />
          </div>
        </div>
      </div>

      {hasNativePrice &&
        <div className="account-table-row">
          <div className="account-table-row-title">
            <FormattedMessage id="account.setting.title.currency" defaultMessage="Site Currency" />
          </div>
          <div className="account-table-row-content">
            <div className="account-table-details-container">
              {`${languageLabel} (${currencyName})`}
              {hasNativePrice && languageLabel !== currencyName &&
                <div className="account-table-details-smallprint">
                  <FormattedMessage
                    id="account-language.currency-info"
                    defaultMessage="Exchange rates may vary. You will be charged in "
                  />
                  <span>
                    {`${currencyName} (${currencyCode}).`}
                  </span>
                </div>
              }
            </div>
            <div className="account-table-action-container">
              <LanguageModalButton hideCaret buttonText={formatMessage(messages.changeCurrency)} />
            </div>
          </div>
        </div>
      }
    </React.Fragment>
  );
}

AccountLanguage.propTypes = {
  language: PropTypes.shape({}),
};

AccountLanguage.defaultProps = {
  language: {},
};

export default injectIntl(AccountLanguage);
